export const CATEGORIES = [
        { slug: "politica", label: "Política" },
        { slug: "media", label: "Media" },
        { slug: "justica", label: "Justiça" },
        { slug: "economico", label: "Económico" },
        { slug: "social", label: "Social" },
        { slug: "historico", label: "Histórico" },
        { slug: "ciencia_saude", label: "Ciência e Saúde" },
        { slug: "religiao", label: "Religião" },
        { slug: "esoterismo", label: "Esoterismo" },
];

export const EDITORIAL_STATUSES = [
        { value: "draft", label: "Pendente" },
        { value: "review", label: "Em revisão" },
        { value: "published", label: "Publicado" },
        { value: "archived", label: "Arquivado" },
];

export const RELEVANCE_SCOPES = [
        { value: "portugal_direto", label: "Portugal direto" },
        { value: "externo_relevante", label: "Externo relevante" },
        { value: "manual_editorial", label: "Decisão editorial manual" },
        { value: "fora_de_escopo", label: "Fora de escopo" },
];

export const emptyForm = () => ({
        title: "",
        category: "politica",
        editorial_status: "published",
        relevance_scope: "portugal_direto",
        portugal_relevance: "",
        summary: "",
        controversy_score: 50,
        tags: [],
        verified_facts: [],
        media_narratives: [],
        deception_strategy: "",
        full_article: "",
        ai_analysis: "",
        ai_model_used: null,
        quality_warnings: [],
        sources: [],
        image_url: "",
        image_suggestions: [],
});
